import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { Bourse } from '../components/Bourse';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-image: url('assets/images/actualite.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 17px;
        padding: 12px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
      color: ${YELLOW};
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      // background-color: green;
    }
  }
`;

export const BoursePage = () => {
  const history = useHistory();
  // const [option, setOption] = useState('1');

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10}>
              <Image
                alt='moranje-logo'
                src='assets/images/moranje-logo.png'
                width={130}
                preview={false}
                style={{ objectFit: 'contain' }}
              />
              <div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 35,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 30,
                  }}
                >
                  Réseau
                </div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item onClick={() => history.push(ROUTES.HOME_PAGE)}>
                <span style={{ cursor: 'pointer' }}>
                  <FaHome style={{ marginRight: 5 }} />
                  <span>Accueil</span>
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Réseau</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

            <div className='menus'>
              {/*   {RESEAU.map((res, i) => (
                <p key={i} onClick={() => {}}>
                  {res.label}
                </p>
              ))} */}
            </div>
          </div>
        </div>

        <div className='content'>
          <h2>Liste des sociétés agrées</h2>
          <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
          <Bourse />
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};

// const RESEAU = [
//   {
//     label: 'Société de bourses',
//     option: '1',
//   },
//   {
//     label: 'Réseau',
//     option: '2',
//   },
//   {
//     label: 'Membres',
//     option: '3',
//   },
//   {
//     label: 'Banques',
//     option: '4',
//   },
// ];
